import TabView from "Components/MUI_components/tab";
import SingleEntry from "./SingleEntry";
import DoubleEntry from "./DoubleEntry";

const AddJournalType = (props) => {
  const tabView = [
    {
      title: "Single Entry",
      component: <SingleEntry {...props} />,
    },
    {
      title: "Double Entry",
      component: <DoubleEntry {...props} />,
    },
  ];
  return (
    <div style={{ margin: 20 }}>
      <TabView tabViews={tabView} />
    </div>
  );
};

export default AddJournalType;
